<template>
   
    <div class='event-info row mb-5'>
        <div class="col-12">
            <h1  v-to="'/event/'+event.id"> {{ event.name }} </h1>
            <div>
                <span class='f4 o-50 ttu '> <date :date="event.start"></date> </span>
                <span v-if="event.end" class='f4 o-50 ttu '> 
                    
                    <!-- - <date :date="event.end"></date>  -->
                    
                    </span>
            </div>
            <div class='mt-3 gray'> {{ event.description }} </div>
        </div>
    </div>

</template>

<script>
export default {
    props:{
        event:{
            default:{name:""}
        }
    }
}
</script>

<style lang="stylus">

    .event-info{
        h1{
            color:cor-ciano;
            margin-bottom:5px;
        }
    }
</style>
